<template>
  <v-container
    id="jobClassSummary"
  >
    <v-progress-linear
      v-show="loading"
      indeterminate
      color="green"
    />
    <div>
      <div class="oe-summary-title">
        <v-btn
          class="mx-2"
          fab
          dark
          x-small
          :color="approvals.color"
          @click="displaySection = !displaySection"
        >
          <v-icon
            v-show="!displaySection"
            dark
          >
            mdi-arrow-expand-vertical
          </v-icon>
          <v-icon
            v-show="displaySection"
            dark
          >
            mdi-arrow-expand-horizontal
          </v-icon>
        </v-btn>
        Job Class Summary
      </div>
      <v-fab-transition>
        <note
          v-show="displaySection"
          :open-enrollment="openEnrollment"
          :section="sections.jobClass"
          summary="true"
        />
      </v-fab-transition>
      <v-container
        v-if="!loading && jobClasses && jobClasses.length"
        fluid
      >
        <v-row dense>
          <v-col
            v-for="(jobClass, i) in jobClasses"
            :key="i"
          >
            <v-fab-transition>
              <v-card
                v-show="displaySection"
                class="job-class-summary"
              >
                <v-card-text>
                  <div class="display-2 text--primary">
                    <span v-text="jobClass.jobClassName" />
                  </div>
                  <base-display-value
                    v-model="jobClass.jobClassDesc"
                    label="Description"
                    class="mt-2"
                  />
                  <base-display-value
                    v-model="jobClass.benefitEligible"
                    label="Benefit Eligible"
                    data-type="boolean"
                    class="mt-2"
                  />
                  <base-display-value
                    v-model="jobClass.payGroup"
                    label="Pay Group"
                    class="mt-2"
                  />
                </v-card-text>
              </v-card>
            </v-fab-transition>
          </v-col>
        </v-row>
      </v-container>
      <v-fab-transition>
        <v-alert
          v-show="displaySection && (!loading && (!jobClasses || !jobClasses.length))"
          type="info"
        >
          No job class details found
        </v-alert>
      </v-fab-transition>
      <v-fab-transition>
        <approval
          v-show="displaySection"
          :approvals="approvals"
          :allow-change="!print"
          @approval:changed="$emit('approval:changed')"
        />
      </v-fab-transition>
    </div>
    <base-material-snackbar
      v-model="displayError"
      type="error"
      v-bind="{
        top: true,
        right: true
      }"
    >
      {{ errorMessage }}
    </base-material-snackbar>
  </v-container>
</template>

<script>
  import TroodyApi from '@/services/troody/TroodyApi'
  import Approvals from '@/services/troody/Approvals'

  export default {
    name: 'JobClassSummary',

    components: {
      Note: () => import('./Note'),
      Approval: () => import('./Approval'),
    },

    props: {
      expanded: {
        type: Boolean,
        default: false,
      },
      openEnrollment: {
        type: Object,
        default: null,
      },
      print: {
        type: Boolean,
        default: false,
      },
    },

    data: () => ({
      displaySection: true,

      loadingJobClass: false,

      errorMessage: null,
      displayError: false,
      formErrors: {},

      jobClasses: null,

      jobClassResource: new TroodyApi('oeJobClass/'),
      approvals: null,
    }),

    computed: {
      loading () {
        return (this.loadingJobClass)
      },

      sections () {
        return Approvals.sections
      },
    },

    watch: {
      expanded (val) {
        this.displaySection = val
      },
    },

    created () {
      this.initialize()
    },

    methods: {
      initialize () {
        this.formErrors = {}
        this.loadJobClass()
        this.approvals = new Approvals(this.openEnrollment.id, Approvals.sections.jobClass.id)
        this.displaySection = this.expanded
      },

      loadJobClass () {
        this.loadingJobClass = true
        this.jobClassResource.query({ openEnrollmentId: this.openEnrollment.id })
          .then(data => {
            console.log('jobClass')
            console.log(data)
            this.loadingJobClass = false
            this.jobClasses = data
          })
          .catch((error) => {
            this.loadingJobClass = false
            this.jobClasses = null
            this.showError(error, 'Failed to load job class details!')
          })
      },

      showError (error, msg) {
        console.log(error)
        this.errorMessage = (error || msg)
        this.displayError = true
      },
    },
  }
</script>

<style lang="sass">
  .job-class-summary
    border-width: 3px
    border-style: solid
    border-color: rgba(0, 255, 0, 0.1) !important
    border-radius: 10px !important
    margin: 4px !important
</style>
